import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  name: [
    {...makeRule()},
  ],
}

export let formRules = {
  tags: [
    {...makeRule('请至少选择一个标签', 'array')},
  ],
  userids: [
    {...makeRule('请至少添加一个用户', 'string')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/user-batch-tag/user-batch-tag.rules.js